import { SecondaryMenuItemProps } from './MobileMenu.types'
import { Bullet, SecondaryItem, SecondaryUl } from './SecondaryMenu.styles'

interface SecondaryMenuProps {
  items: SecondaryMenuItemProps[]
  onSelect: () => void
}

const bullet = <Bullet>●</Bullet>

export const SecondaryMenu = ({ items, onSelect }: SecondaryMenuProps) => {
  if (!items) return null

  return (
    <SecondaryUl>
      {items.map((item, key: number) => (
        <a
          key={key}
          className={item.active ? 'active' : ''}
          href="#/"
          onClick={e => {
            e.preventDefault()
            item.onClick()
            onSelect()
          }}
        >
          <SecondaryItem>
            {bullet}
            {item.labelComponent || item.titleComponent || item.title}
          </SecondaryItem>
        </a>
      ))}
    </SecondaryUl>
  )
}
